import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    Grid, TextField, FormControl, InputLabel, Select, MenuItem,
    CircularProgress, Box, Chip
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { FormatarDinherio } from '../helpers/FormatarBrl';
import { EditarGruposSchema } from '../schemes/EdicaoDeGrupos';


export default function ModalEdicaoGrupos({ open, onClose, onSave, grupos, isLoading }) {

    const [filtros, setFiltros] = useState({
        nome: '',
        status: '',
        cod_grupo: '',
    });

    const [erroNomegrupos, seterroNomegrupos] = useState(false);
    const [erroNomegruposMessage, seterroNomegruposMessage] = useState('');

    const [erroCodigoGrupos, seterroCodigoGrupos] = useState(false);
    const [erroCodigoGruposMessage, setererroCodigoGruposMessage] = useState('');

    const [erroStatusGrupos, seterroStatusGrupos] = useState(false);
    const [erroStatusGruposMessage, seterroStatusGruposMessage] = useState('');


    useEffect(() => {
        if (grupos) {
            setFiltros({
                nome: grupos.nome,
                status: grupos.online,
                cod_grupos: grupos.cod_grupo,
            });
        }
    }, [grupos]);


    const handleChange = (e) => {
        let { name, value } = e.target;

        if (name === 'valor') {
            let somenteNumeros = value.replace(/\D/g, '');
            let numero = parseFloat(somenteNumeros) / 100;
            let valor_formatado = FormatarDinherio(numero);
            setFiltros(prev => ({ ...prev, [name]: valor_formatado }));
        } else {
            setFiltros(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        let nome = filtros.nome;
        let cod_grupos = filtros.cod_grupos;
        let status = filtros.status;

        const result = EditarGruposSchema.safeParse({ nome, cod_grupos, status });

        if (!result.success) {
            const errors = result.error.format();

            if (errors.nome?._errors?.length) {
                seterroNomegrupos(true);
                seterroNomegruposMessage(errors.nome._errors[0]);
            } else {
                seterroNomegrupos(false);
                seterroNomegruposMessage('');
            }

            if (errors.cod_grupos?._errors?.length) {
                seterroCodigoGrupos(true);
                setererroCodigoGruposMessage(errors.cod_grupos._errors[0]);
            } else {
                seterroCodigoGrupos(false);
                setererroCodigoGruposMessage('');
            }

            if (errors.status?._errors?.length) {
                seterroStatusGrupos(true)
                seterroStatusGruposMessage(errors.status._errors[0]);
            } else {
                seterroStatusGrupos(false)
                seterroStatusGruposMessage('');
            }
            return;
        }
        onSave(filtros);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Editar grupos</DialogTitle>
            <Box
                component="form"
                onSubmit={handleSubmit}
            >
                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item
                            size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}
                        >
                            <TextField
                                type='number'
                                fullWidth
                                name="cod_grupos"
                                value={filtros.cod_grupos}
                                onChange={handleChange}
                                label='Código do grupo'
                                variant="outlined"
                                InputProps={{
                                    readOnly: true,
                                    sx: { backgroundColor: 'white', color: 'black' }
                                }}
                                InputLabelProps={{
                                    sx: { bgcolor: 'white', px: 0.5, color: 'black' }
                                }}
                                required
                                error={erroCodigoGrupos}
                                helperText={erroCodigoGrupos ? erroCodigoGruposMessage : ''}

                            />
                        </Grid>
                        
                        <Grid item
                            size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}
                        >
                            <TextField
                                fullWidth
                                name="nome"
                                value={filtros.nome}
                                onChange={handleChange}
                                label='Nome do produto'
                                variant="outlined"
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                                required
                                error={erroNomegrupos}
                                helperText={erroNomegrupos ? erroNomegruposMessage : ''}
                            />
                        </Grid>

                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <TextField
                                select
                                fullWidth
                                label="Ativo"
                                name="status"
                                value={filtros.status === '' ? 'S' : filtros.status}
                                onChange={handleChange}
                                variant="outlined"
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                                required
                                error={erroStatusGrupos}
                                helperText={erroStatusGrupos ? erroStatusGruposMessage : ''}

                            >
                                <MenuItem value="S">Sim</MenuItem>
                                <MenuItem value="N">Não</MenuItem>
                            </TextField>
                        </Grid>

                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="secondary">Cancelar</Button>
                    <Button
                        type="submit"
                        variant="outlined"
                        startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                        disabled={isLoading}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
}